<template>
    <div>
      <div class="hlCenter1">
        <div class="book">
          <img src="https://gcjy-images-cdn.ahsjxjy.com/ahjxjy-v2/prod/ahsjxjy-New-WebApi/2025/04/11/ahsjxjy-New-WebApi_1744354771828.png" alt="铜仁学院省级专业技术人员继续教育培训平台" />
        </div>
        <div style="display: flex; flex-direction: column; align-items: center">
          <div
            :class="['t1', { active: activeItem === 'courseInto' }]"
            style="margin-top: 40px"
            @click="scrollToView('courseInto')"
          >
            课程介绍
          </div>
          <span class="line1"></span>
          <div
            :class="['t1', { active: activeItem === 'contents' }]"
            @click="scrollToView('contents')"
          >
            课程目录
          </div>
          <span class="line1"></span>
          <div
            :class="['t1', { active: activeItem === 'tearchInfo' }]"
            @click="scrollToView('tearchInfo')"
          >
            讲师介绍
          </div>
          <span class="line1"></span>
          <div
            :class="['t1', { active: activeItem === 'analysis' }]"
            @click="scrollToView('analysis')"
          >
            就业分析
          </div>
          <span class="line1"></span>
          <div
            :class="['t1', { active: activeItem === 'advantages' }]"
            @click="scrollToView('advantages')"
          >
            班级优势
          </div>
          <span class="line1"></span>
          <div
            :class="['t1', { active: activeItem === 'evaluation' }]"
            @click="scrollToView('evaluation')"
          >
            学员评价
          </div>
          <span class="line1"></span>
          <div
            :class="['t1', { active: activeItem === 'guide' }]"
            @click="scrollToView('guide')"
          >
            购买指南
          </div>
        </div>
      </div>
  
    </div>
  </template>
  
  <script>
  export default {
    data() {
      return {
        ewm: '',
        activeItem: '', 
        isClicking: false, 
      };
    },
    methods: {
      scrollToView(item) {
        this.isClicking = true; 
        this.activeItem = item;
        document.getElementById(`${item}`).scrollIntoView({ behavior: 'smooth' });
        setTimeout(() => {
          this.isClicking = false;
        }, 1000); 
      },
      handleScroll() {

        if (this.isClicking){
            return;
        }else{
             const sections = [
          'courseInto',
          'contents',
          'tearchInfo',
          'analysis',
          'advantages',
          'evaluation',
          'guide',
        ];
        let currentActive = ''; 
        for (let i = sections.length - 1; i >= 0; i--) {
          const section = document.getElementById(sections[i]);
          if (section) {
            const rect = section.getBoundingClientRect();
            if (rect.top <= 100) {
              currentActive = sections[i];
              break;
            }
          }
        }
        this.activeItem = currentActive; 
          
        }
       
      
      },
    },
    mounted() {
        window.addEventListener('scroll', this.handleScroll); 


    },
    beforeDestroy() {
      window.removeEventListener('scroll', this.handleScroll); 
    },
  };
  </script>
  
  <style>
  .hlCenter1 {
    z-index: 10000;
    position: fixed;
    top: 29%;
    left: 20px;
    width: 84px;
    height: 434px;
    background: linear-gradient(90deg, #4076f6 0%, #5582f8 100%);
    box-shadow: 0px 5px 10px 0px rgba(0, 0, 0, 0.1);
    border-radius: 35px 35px 12px 12px;
  }
  .book {
    width: 84px;
    position: absolute;
    top: -18px;
    left: 0;
    height: 60px;
    img {
      width: 100%;
      height: 100%;
    }
  }
  .t1 {
    height: 53px;
    font-family: PingFang SC, PingFang SC;
    font-weight: 400;
    font-size: 14px;
    color: rgba(255, 255, 255, 0.6);
    line-height: 53px;
    text-align: center;
    cursor: pointer;
  }
  .line1 {
    width: 20px;
    height: 0px;
    border-bottom: 1px solid rgba(255, 255, 255, 0.2);
    display: inline-block;
  }
  .active {
    font-family: PingFang SC, PingFang SC;
    font-weight: 500;
    font-size: 14px;
    color: #ffffff;
  }
  </style>